import { useAuth } from "../../../../context";
import { useMutation, useQuery } from "react-query";
import { EmployeeCommuting } from "../../../../api";

export const employeeCommutingKeys = {
  items: () => ["employeeCommutingItems"]
};

export function useGetEmployeeCommutingItems(params, config) {
  const { callApi } = useAuth();
  return useQuery(
    [...employeeCommutingKeys.items(), params.queryParams.page, params.queryParams.size, params.queryParams.sort],
    () => callApi(EmployeeCommuting.getEmployeeCommutingItems, params), config);
}

export function useAddEmployeeCommutingItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(EmployeeCommuting.addEmployeeCommutingItems, { questionnaireId, data }), config);
}

export function useUpdateEmployeeCommutingItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId, data }) =>
    callApi(EmployeeCommuting.updateEmployeeCommutingItem, { questionnaireId, recordId, data }), config);
}

export function useDeleteEmployeeCommutingItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId }) =>
    callApi(EmployeeCommuting.deleteEmployeeCommutingItem, { questionnaireId, recordId }), config);
}

export function useImportEmployeeCommutingItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(EmployeeCommuting.importEmployeeCommutingItems, { questionnaireId, data }), config);
}

export function useDownloadEmployeeCommutingTemplate(config) {
  const { callApi } = useAuth();
  return useMutation(() => callApi(EmployeeCommuting.getEmployeeCommutingTemplate), config);
}